import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { DocumentService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
  areas?: any;
}

class ModalCreate extends React.Component<Props> {
  state = {
    form: {
      area_id: '',
      name: '',
    },
    areas: this.props.areas || [],
  };

  componentDidMount() {
    if (this.props.item) {
      this.setState({
        form: {
          ...this.state.form,
          name: this.props.item?.name || '',
          area_id: this.props.item?.area_id || '',
        },
      });
    }
  }

  submit = async (e: any) => {
    e.preventDefault();

    if (this.props.item != null) {
      await DocumentService.admin.create({
        document_id: this.props.item?.id,
        ...this.state.form,
      });
      Globals.showSuccess('Se ha modificado el documento correctamente');
      this.props.onClose();
    } else {
      await DocumentService.admin.create({
        ...this.state.form,
      });
      Globals.showSuccess('Se ha creado el documento correctamente');
      this.props.onClose();
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    return (
      <div id="modal-create-document">
        <form onSubmit={this.submit}>
          <div className="container-inputs">
            <div className="row">
              <div className="col-md-12">
                <Input
                  color="white"
                  value={this.state.form.name}
                  name="name"
                  label="Nombre"
                  className="price-input"
                  onChange={this.change}
                />
              </div>
              <div className="col-md-12">
                <Select
                  color="white"
                  placeholder="Seleccionar"
                  label="Tipo de derecho"
                  name="area_id"
                  onChange={this.change}
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
            </div>
          </div>
          <div className="text-center">
            <Button type="submit">Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ModalCreate;
